"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardConfigProvider = exports.useDashboardConfigContext = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var DashboardConfigContext = react_1.createContext({
    menuButtonConfig: {},
});
DashboardConfigContext.displayName = "DashboardConfigContext";
/**
 * Context for all the dashboard level configuration of the presentation components.
 * @alpha
 */
exports.useDashboardConfigContext = function () {
    return react_1.useContext(DashboardConfigContext);
};
/**
 * @internal
 */
exports.DashboardConfigProvider = function (props) {
    var children = props.children, components = tslib_1.__rest(props, ["children"]);
    return react_1.default.createElement(DashboardConfigContext.Provider, { value: components }, children);
};
//# sourceMappingURL=DashboardConfigContext.js.map